import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

interface CustomTabsProps {
    tabs: Array<any>;
    tabActive: string;
    changeTab: (data: any) => void;
}

const CustomTab = ({ tabs, tabActive, changeTab }: CustomTabsProps) => {
    return (
        <Box sx={{ borderBottom: 1, borderColor: "divider" }} mb={2} mt={4}>
            <Tabs value={tabActive} indicatorColor='secondary' textColor='secondary' >
                {tabs.map((item, index) => {
                    return <Tab key={index} label={item.title} value={item.type ? `${item.name}-${item.type}` : item.name} onClick={changeTab.bind(this, item)} 
                    sx={{textTransform: 'none', fontWeight: 700, fontFamily: 'Muli,sans-serif', fontSize: 14}} />
                })}
            </Tabs>  
        </Box>
    );
};

export default CustomTab;
